import React, { memo, useState, useEffect } from 'react'
import { Button, BodyText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { fptiCustomSetup, serverData } from '../../utils'

const SMSSentPage = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)
  const { dsrFpti = {} } = props

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(dsrFpti.SENT_IMPRESSION)
    }
  }, [impressionDone, dsrFpti])

  return (
    <>
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen">
            <div className="icon-container">
              <img
                src={`https://${serverData.cdnHostName}/dataprivacy/digitalassets/dar/application-check-status.svg`}
                alt="sms-sent"
              />
            </div>
            <BodyText>
              <Message
                id="closedAccountPages.passwordsent.description"
                phonenumber={props.response.masked_phone_number || ''}
              />
            </BodyText>
            <div className="button-container">
              <Button as="a" href="/" role="button">
                <Message id="dar.section.success.buttonlabel" />
              </Button>
            </div>
          </section>
        </div>
      </section>
    </>
  )
})
SMSSentPage.displayName = 'SMSSentPage'

export default SMSSentPage
